import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const CardPagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: ${({ theme }) => `${utils.rem(theme.Spacing.Size.Large)}`};
  transition: opacity 0.5s ease-in-out;
`;

const PagesWrapper = styled.div`
  display: inline-block;
  border-radius: ${({ theme }) => `${utils.rem(theme.Border.Radius.Large)}`};
  background-color: ${({ theme }) => `${theme.Color.NeutralsFixed.Gray}`};
  padding: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XXSmall)}`};
`;

const PagesLabel = styled.div`
  font-family: ${({ theme }) => theme.Typography.Size.Badge.FontFamily};
  font-size: ${({ theme }) => utils.rem(theme.Typography.Size.Badge.FontSize)};
  font-weight: ${({ theme }) => theme.Typography.Size.Badge.FontWeight};
  line-height: ${({ theme }) => utils.rem(theme.Typography.Size.Badge.LineHeight)};
  color: ${({ theme }) => `${theme.Color.NeutralsFixed.Paper}`};
`;

export const CardPagesStyles = {
  CardPagesWrapper,
  PagesWrapper,
  PagesLabel,
};
